import 'twin.macro'
import { useEffect, useId, useRef, useState } from 'react'
import { useLocation } from '@reach/router'
import LabelFloating from './label-floating'

interface Props extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label: string
  initialValue?: string
  onUpdate?: (arg: string) => void
  tooltip?: string
}

export default function TextArea(props: Props): JSX.Element {
  const { label, initialValue, onUpdate, tooltip, ...inputProps } = props

  const ref = useRef<HTMLTextAreaElement>()
  const uid = useId()
  const { search } = useLocation()

  const [hasFocus, setFocus] = useState(false)
  const [input, setInput] = useState('')

  useEffect(() => {
    const defVal = new URLSearchParams(search).get(inputProps.name) || (initialValue as string)
    if (defVal) setInput(defVal)

    if (document.hasFocus() && ref.current === document.activeElement) setFocus(true)
  }, [])

  useEffect(() => {
    if (onUpdate) onUpdate(input)
  }, [input])

  return (
    <LabelFloating
      label={label}
      uid={uid}
      hasFocus={hasFocus}
      hasInput={input?.length > 0}
      required={inputProps.required}
      name={inputProps.name}
      tooltip={tooltip}
    >
      <textarea
        ref={ref}
        id={uid}
        defaultValue={input}
        onChange={(event) => setInput(event.target.value)}
        onFocus={() => setFocus(true)}
        onBlur={() => setFocus(false)}
        tw="px-3 py-2 text-gray-700 text-lg w-full outline-none bg-inherit"
        {...inputProps}
      />
    </LabelFloating>
  )
}
